module.exports = __webpack_public_path__ + "img/01n.a078e096.png";